export const PAYMENT_STATUS = Object.freeze({
  PENDING: 'PENDING',
  PARTIAL: 'PARTIAL',
  AWAITING_RECONCILIATION: 'AWAITING_RECONCILIATION',
  PAID: 'PAID',
  VOID: 'VOID',
});

export const PAYMENT_STATUS_ALIASES = Object.freeze({
  PP: PAYMENT_STATUS.PENDING,
  PPP: PAYMENT_STATUS.PARTIAL,
  PR: PAYMENT_STATUS.PAID,
  PS: PAYMENT_STATUS.PAID,
  PA: PAYMENT_STATUS.VOID,
});

export const PAYMENT_FILTER_ALL = 'todas';

const CURRENT_PAYMENT_STATUSES = new Set(Object.values(PAYMENT_STATUS));

export const normalizePaymentStatus = (value, fallback = PAYMENT_STATUS.PENDING) => {
  const raw = String(value ?? '').trim().toUpperCase();
  const normalized = PAYMENT_STATUS_ALIASES[raw] || raw;
  return CURRENT_PAYMENT_STATUSES.has(normalized) ? normalized : fallback;
};

export const normalizePaymentFilter = (value) => {
  const raw = String(value ?? '').trim().toUpperCase();
  if (!raw || raw === 'ALL' || raw === 'TODAS') return PAYMENT_FILTER_ALL;
  return normalizePaymentStatus(raw, null) || PAYMENT_FILTER_ALL;
};

export const normalizeInvoicePaymentStatus = (
  invoice,
  rawStatus = invoice?.paymentStatus,
  fallback = PAYMENT_STATUS.PENDING,
) => {
  if (!invoice || typeof invoice !== 'object') return invoice;
  return {
    ...invoice,
    paymentStatus: normalizePaymentStatus(rawStatus, fallback),
  };
};
